<template>
    <div>
        <div @mousemove="mouseMoveHnalder" @mousewheel="mouseWheel" ref="generalContainer" class="general-container"
             :style="{width: `${width}px`, height: `${height}px`}">
            <div @DOMMouseScroll="mouseWheel" @mousedown="slotMouseDownHandler" ref="slotContianer"
                 class="slot-container"
                 :style="{left: `${left}px`, top: `${top}px`}">
                <!--                <slot></slot>-->
                <img ref="image" :style="{width: imageWidthStyle, height: imageHeightStyle}" @dragstart.prevent :src="src" alt="">
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        name: "index",
        props: {
            width: {
                default: 300,
                type: Number
            },
            height: {
                default: 400,
                type: Number
            },
            scaleStep: {
                default: 0.1,
                type: Number
            },
            scaleMin: {
                default: 0.2,
                type: Number
            },
            scaleMax: {
                default: 1,
                type: Number
            },
            picUrl: {
                required: true,
                type: String
            }
        },
        data() {
            return {
                mouseOffX: 0,
                mouseOffY: 0,
                left: 0,
                top: 0,
                scaleValue: 1,
                canMove: false,
                src: '',
                imageWidth: 0,
                imageHeight: 0,
                originalWidth: 0,
                originalHeight: 0,
            }
        },
        watch: {
            picUrl(url) {
                this.initImage(url);
            }
        },
        computed: {
            imageWidthStyle() {
                return this.imageWidth ? `${this.imageWidth}px` : 'auto';
            },
            imageHeightStyle() {
                return this.imageHeight ? `${this.imageHeight}px` : 'auto';
            }
        },
        mounted() {
            this.initImage(this.picUrl);
            document.addEventListener('mouseup', () => {
                setTimeout(() => {
                    this.canMove = false;
                    this.checkBoundry();
                }, 200);
            })
        },
        beforeDestroy() {
            document.removeEventListener('mouseup')
        },
        methods: {
            initImage(url) {
                if (url) {
                    const [baseUrl, extra] = url.split('?');
                    this.src = baseUrl;
                    setTimeout(() => {
                        this.imageWidth = this.$refs.image.width;
                        this.imageHeight = this.$refs.image.height;
                        this.originalWidth = this.$refs.image.width;
                        this.originalHeight = this.$refs.image.height;
                        const scaleMatchArray = /imageMogr2\/thumbnail\/!([\d.]+)p/g.exec(extra);
                        if(scaleMatchArray && scaleMatchArray[0]) {
                            const scaleValue = Number.parseFloat(scaleMatchArray[1]);
                            this.imageWidth = this.originalWidth * scaleValue / 100;
                            this.imageHeight = this.originalHeight * scaleValue / 100;
                            this.scaleValue = Number.parseFloat(scaleValue / 100);
                        }
                        const positionValue = /imageMogr2\/cut\/[\d.]+x[\d.]+x([\d.]+)x([\d.]+)/g.exec(extra);
                        if(positionValue && positionValue[0]) {
                            this.left = -parseFloat(positionValue[1]);
                            this.top = -parseFloat(positionValue[2]);
                        }
                    }, 300);

                }
            },
            checkBoundry() {
                if (this.left > 0) {
                    this.left = 0;
                }
                if (this.top > 0) {
                    this.top = 0;
                }
            },
            slotMouseDownHandler(event) {
                const rectX = this.$refs.slotContianer.getBoundingClientRect().x;
                const rectY = this.$refs.slotContianer.getBoundingClientRect().y;
                this.canMove = true;
                this.mouseOffX = event.clientX - rectX;
                this.mouseOffY = event.clientY - rectY;
            },
            mouseMoveHnalder(event) {
                if (this.canMove) {
                    this.left = event.pageX - this.$refs.generalContainer.getBoundingClientRect().x - this.mouseOffX;
                    this.top = event.pageY - this.$refs.generalContainer.getBoundingClientRect().y - this.mouseOffY;
                }
            },
            mouseWheel(event) {
                const delta = (event.wheelDelta && (event.wheelDelta > 0 ? 1 : -1)) ||  // chrome & ie
                    (event.detail && (event.detail > 0 ? -1 : 1));
                let scaleValue = this.scaleValue;
                if (delta > 0 && this.scaleValue < this.scaleMax) {
                    scaleValue = Math.floor(this.scaleValue * (1 + this.scaleStep) * 100) / 100;
                } else if (delta < 0 && this.scaleValue > this.scaleMin) {
                    scaleValue = Math.floor(this.scaleValue * (1 - this.scaleStep) * 100) / 100;
                }
                this.imageWidth = this.originalWidth * scaleValue;
                this.imageHeight = this.originalHeight * scaleValue;
                this.scaleValue = Number.parseFloat(scaleValue);
            },
            getLeft() {
                return this.left;
            },
            getTop() {
                return this.top;
            },
            setTop(top) {
                this.top = top;
            },
            setLeft(left) {
                this.left = left;
            },
            getScale() {
                return this.scaleValue;
            },
            setScale(scale) {
                this.scaleValue = scale;
            },
            getUrl() {
                const index = this.picUrl.lastIndexOf('?');
                let src = this.picUrl;
                if (index !== -1) {
                    src.slice(0, index);
                }
                const top = Math.abs(this.top);
                const left = Math.abs(this.left);
                return `${this.src}?imageMogr2/thumbnail/!${this.scaleValue * 100}p|imageMogr2/cut/${this.width}x${this.height}x${left}x${top}`;
            },
            getOriginalUrl() {
                return this.src;
            }
        }
    }
</script>

<style scoped>
    .general-container {
        position: relative;
        overflow: hidden;
        border: 1px solid #000;
        box-sizing: border-box;
    }
    .slot-container {
        position: absolute;
        transition: all 100ms linear;
        transform-origin: 0 0;
        img {
            transition: all 100ms linear;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ImageDragger/index.vue